(function () {
  
  function normalizeLetter(title) {
    var c = String(title || '').trim().charAt(0);
    try {
      c = c.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } catch (e) {}
    return c.toUpperCase();
  }

  function buildLetterColumns(root) {
    var groups = root.querySelectorAll('[data-marques-group]');
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var host = group.querySelector('[data-marques-cols]');
      var tpl = group.querySelector('template[data-marques-source]');
      if (!host || !tpl) continue;
      var maxPer = parseInt(host.getAttribute('data-max-per-col') || '8', 10) || 8;
      var links = tpl.content.querySelectorAll('[data-marques-brand]');
      var byLetter = {};
      var order = [];
      for (var i = 0; i < links.length; i++) {
        var a = links[i];
        var title = a.getAttribute('data-title') || a.textContent || '';
        var L = normalizeLetter(title);
        if (!byLetter[L]) {
          byLetter[L] = [];
          order.push(L);
        }
        byLetter[L].push({ href: a.getAttribute('href') || '#', title: title });
      }
      host.innerHTML = '';
      var colCount = 0;
      for (var o = 0; o < order.length; o++) {
        var letter = order[o];
        var brands = byLetter[letter];
        var subcols = Math.max(1, Math.ceil(brands.length / maxPer));
        var wrap = document.createElement('div');
        wrap.className = 'marques-nav__letter-span';
        wrap.style.setProperty('--subcols', String(subcols));

        var sep = document.createElement('p');
        sep.className = 'marques-nav__letter-sep';
        sep.textContent = letter;
        wrap.appendChild(sep);

        var cols = document.createElement('div');
        cols.className = 'marques-nav__letter-span-cols';
        for (var start = 0; start < brands.length; start += maxPer) {
          var chunk = brands.slice(start, start + maxPer);
          var ul = document.createElement('ul');
          ul.className = 'marques-nav__brands';
          for (var b = 0; b < chunk.length; b++) {
            var li = document.createElement('li');
            var link = document.createElement('a');
            link.href = chunk[b].href;
            link.className = 'marques-nav__brand';
            link.textContent = chunk[b].title;
            li.appendChild(link);
            ul.appendChild(li);
          }
          cols.appendChild(ul);
          colCount++;
        }
        wrap.appendChild(cols);
        host.appendChild(wrap);
      }
      host.style.setProperty('--letter-cols', String(Math.max(colCount, 1)));
    }
  }

  function setActiveLetter(root, letterId) {
    var buttons = root.querySelectorAll('[data-marques-letter]');
    var groups = root.querySelectorAll('[data-marques-group]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var on = btn.getAttribute('data-marques-letter') === letterId;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var match = group.getAttribute('data-marques-group') === letterId;
      group.classList.toggle('is-active', match);
      if (match) group.removeAttribute('hidden');
      else group.setAttribute('hidden', '');
    }
    root.setAttribute('data-active-letter', letterId || '');
  }

  var cachedParfumsH = 0;

  function applyMarquesHeight(h) {
    if (!h || h < 120) return;
    var marquesMenu = document.querySelector('.site-nav--marques .marques-nav-dropdown.megaMenu');
    if (!marquesMenu) return;
    if (window.matchMedia && !window.matchMedia('(min-width: 1200px)').matches) {
      marquesMenu.style.height = '';
      marquesMenu.style.minHeight = '';
      return;
    }
    marquesMenu.style.boxSizing = 'border-box';
    marquesMenu.style.height = Math.round(h) + 'px';
    marquesMenu.style.minHeight = Math.round(h) + 'px';
  }

  function measureParfumsHeight() {
    var li = document.querySelector('li.fs-mega-parfums');
    if (!li) return 0;
    var dd = li.querySelector('.dropdown_menu');
    var menu = li.querySelector('.site-nav__dropdown.megaMenu');
    if (!dd || !menu) return 0;

    var prevDd = dd.style.cssText;
    var prevMenu = menu.style.cssText;

    dd.style.cssText =
      'display:block!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;position:absolute!important;left:0!important;right:0!important;top:0!important;transform:none!important;z-index:-1!important;';
    menu.style.cssText =
      (prevMenu ? prevMenu + ';' : '') +
      'display:block!important;visibility:hidden!important;opacity:1!important;position:static!important;transform:none!important;';

    var h = Math.round(menu.getBoundingClientRect().height || menu.offsetHeight || 0);

    dd.style.cssText = prevDd;
    menu.style.cssText = prevMenu;

    return h;
  }

  function syncMarquesHeightToParfums() {
    var h = measureParfumsHeight();
    if (h > 120) {
      cachedParfumsH = h;
      applyMarquesHeight(h);
      return;
    }
    if (cachedParfumsH > 120) applyMarquesHeight(cachedParfumsH);
  }

  function bindParfumsCapture() {
    var li = document.querySelector('li.fs-mega-parfums');
    if (!li || li.getAttribute('data-fs-h-bound') === '1') return;
    li.setAttribute('data-fs-h-bound', '1');
    li.addEventListener('mouseenter', function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          var menu = li.querySelector('.site-nav__dropdown.megaMenu');
          if (!menu) return;
          var h = Math.round(menu.getBoundingClientRect().height || 0);
          if (h > 120) {
            cachedParfumsH = h;
            applyMarquesHeight(h);
          }
        });
      });
    });
  }

  function initNav(root) {
    if (root.getAttribute('data-marques-ready') === '1') return;
    root.setAttribute('data-marques-ready', '1');
    buildLetterColumns(root);

    var letterBtns = root.querySelectorAll('[data-marques-letter]');
    if (letterBtns.length) {
      setActiveLetter(root, letterBtns[0].getAttribute('data-marques-letter'));
    }
    for (var i = 0; i < letterBtns.length; i++) {
      letterBtns[i].addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setActiveLetter(root, this.getAttribute('data-marques-letter'));
      });
    }
  }

  function initAll() {
    var nodes = document.querySelectorAll('[data-marques-nav]');
    for (var i = 0; i < nodes.length; i++) initNav(nodes[i]);
    bindParfumsCapture();
    syncMarquesHeightToParfums();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('load', function () {
    syncMarquesHeightToParfums();
    window.setTimeout(syncMarquesHeightToParfums, 400);
  });
  window.addEventListener('resize', function () {
    window.clearTimeout(window.__fsMarquesHSync);
    window.__fsMarquesHSync = window.setTimeout(syncMarquesHeightToParfums, 120);
  });
  document.addEventListener('shopify:section:load', initAll);
})();
